// Canonical App Store and Google Play links for the business and customer apps.
export const BUSINESS_IOS_APP_STORE_URL =
  "https://apps.apple.com/gb/app/zedipass-business/id6757428529";
export const BUSINESS_GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.zediapps.retailer";

export const CUSTOMER_IOS_APP_STORE_URL =
  "https://apps.apple.com/gb/app/zedipass/id6753083033";
export const CUSTOMER_GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.zediapps.customer";

// Backwards-compatible customer alias used by referral and legacy CTA code.
export const IOS_APP_STORE_URL = CUSTOMER_IOS_APP_STORE_URL;

// Customer web app (sign in / sign up in the browser). Checked 1 Nov 2026: loads a sign-in page.
export const CUSTOMER_WEB_APP_URL = "https://app.zedipass.com";
